<script setup lang="ts">
import { type ProductDetails, ShippingType } from "mws-ts-v2-sdk";

type Props = {
  product: ProductDetails;
};
const { product } = defineProps<Props>();

const { productTabViewed } = useAnalytics();
const onShowMore = () => {
  productTabViewed({
    tab_name: "Shipping",
    event_name: product.eventName ?? undefined,
    product_name: product.name,
  });
};

const hasNoShipping = computed(
  () => product.shippingType === ShippingType.NoShipping,
);

const platformStore = usePlatformStore();
const isFrameTheGame = computed(() => platformStore.isFrameTheGame);
</script>

<template>
  <ProductDescriptionDrawerBase
    :title="
      hasNoShipping
        ? $t('product.description.shippingDetails.pickUpTitle')
        : $t('product.description.shipping')
    "
    :is-collapsable="!hasNoShipping"
    @show-more="onShowMore"
  >
    <template #content="{ isCollapsed }">
      <p v-if="hasNoShipping">{{ product.shippingDescription }}</p>
      <div
        v-else
        class="flex flex-col gap-2"
      >
        <ProductShippingDetails :product="product" />
        <p
          v-if="!isFrameTheGame"
          class="text-base text-platform-text-2"
        >
          {{ $t("product.description.shippingDetails.combination") }}
        </p>
        <ProductShippingExpandableDescription
          v-show="isCollapsed"
          :shipping-type="product.shippingType"
          :framing-status="product.framingType"
        >
          {{ product.shippingDescription }}
        </ProductShippingExpandableDescription>
      </div>
    </template>
    <template #showMore>
      {{ $t("product.description.shippingDetails.showMore") }}
    </template>
  </ProductDescriptionDrawerBase>
</template>
